/**
* @Description 文件功能说明：应用明细
* @Author
* @Time 2022/1/20
**/

/* HTML */
<template>
    <div class="form-model-view">
    	<div class="title-item-box">
            <span>项目信息</span>
    		<el-button class="title-item-btn" icon="el-icon-circle-plus-outline" style="float: right;" @click="add" v-if="!editFlag && (nodeData.node?nodeData.node.hasArea==1:'')">新增区域</el-button>
    		<el-button class="title-item-btn" icon="el-icon-circle-plus-outline" style="float: right;" @click="add" v-if="!editFlag && (nodeData.node?nodeData.node.hasArea!=1:'')">新增定位地图</el-button>
    		<el-button class="title-item-btn" icon="el-icon-cancel" style="float: right;" v-if="editFlag" @click="cancel">取消</el-button>
    		<el-button class="title-item-btn" icon="el-icon-save" style="float: right;" v-if="editFlag" @click="save">保存编辑</el-button>
    		<el-button class="title-item-btn" icon="el-icon-edit" style="float: right;" v-if="!editFlag" @click="edit">编辑</el-button>
    	</div>
    	<div class="form-unit-box">
    		<el-form :model="rowForm" ref="rowForm" :rules="rules" label-width="120px">
                <el-form-item label="应用ID：" style="display: none;">
                    {{nodeData.parentNode?nodeData.parentNode.appId:''}}
                </el-form-item>
                <el-form-item label="应用类型：" style="display: none;">
                    {{nodeData.parentNode?nodeData.parentNode.appName:''}}
                </el-form-item>
                <el-form-item label="项目ID：">
                    {{nodeData.id}}
                </el-form-item>
                <div v-if="!editFlag">
                    <el-form-item label="项目名称：">
                        {{nodeData.name}}
                    </el-form-item>
                    <el-form-item label="项目地址：" style="display: none;">
                        {{nodeData.node?nodeData.node.website:''}}
                    </el-form-item>
                    <el-form-item label="是否分区域：" style="display: none;">
                        {{nodeData.node?hasAreas[nodeData.node.hasArea]:''}}
                    </el-form-item>
                    <el-form-item label="使用坐标系："  style="display: none;">
                        {{nodeData.node?coordinates[nodeData.node.coordinate]:''}}
                    </el-form-item>
                    <el-form-item label="中心坐标经度：" prop="centerLng" v-if="nodeData.node.coordinate > 0" style="display: none;">
                        {{nodeData.node.centerLng}}
                    </el-form-item>
                    <el-form-item label="中心坐标纬度：" prop="centerLat" v-if="nodeData.node.coordinate > 0" style="display: none;">
                        {{nodeData.node.centerLat}}
                    </el-form-item>
                    <el-form-item label="地图级别：" prop="mapLevel" v-if="nodeData.node.coordinate > 0" style="display: none;">
                        {{nodeData.node.mapLevel}}
                    </el-form-item>
                </div>
                <div v-else>
                    <el-form-item label="项目名称：" prop="name">
                        <el-input v-model="rowForm.name"/>
                    </el-form-item>
                    <el-form-item label="项目地址：" prop="website" style="display: none;">
                        <el-input v-model="rowForm.website"/>
                    </el-form-item>
                    <el-form-item label="是否分区域：" prop="hasArea" style="display: none;">
                        <el-radio-group v-model="rowForm.hasArea" @change="changeAreaHandler">
                            <el-radio class="radio" :label="0" >否</el-radio>
                            <el-radio class="radio" :label="1" >是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="添加区域名：" prop="areaName" v-if="addAreaFlag" style="display: none;">
                        <el-input v-model="rowForm.areaName"/>
                    </el-form-item>
                    <el-form-item label="关联地图：" prop="mapIds" v-if="addAreaFlag" style="display: none;">
                        <el-select v-model="rowForm.mapIds" multiple filterable placeholder="请选择地图" clearable>
                            <el-option v-for="(item,index) in maps" :key="item.mapId" :label="item.mapName" :value="item.mapId" ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="使用坐标系：" prop="coordinate" style="display: none;">
                        <el-radio-group v-model="rowForm.coordinate" @change="changeCoordHandler">
                            <el-radio class="radio" :label="0" >直角坐标系</el-radio>
                            <el-radio class="radio" :label="1" >GPS坐标系</el-radio>
                            <el-radio class="radio" :label="2" >高德地图坐标系</el-radio>
                            <el-radio class="radio" :label="3" >百度地图坐标系<!-- <span class="el-icon-location" @click="clickMap" />--></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="中心坐标经度：" prop="centerLng" v-if="rowForm.coordinate > 0" style="display: none;">
                        <el-input v-model="rowForm.centerLng" placeholder="请输入经度，范围：-180~180" autocomplete="off"/>
                    </el-form-item>
                    <el-form-item label="中心坐标纬度：" prop="centerLat" v-if="rowForm.coordinate > 0" style="display: none;">
                        <el-input v-model="rowForm.centerLat" placeholder="请输入纬度，范围：-90~90" autocomplete="off"/>
                    </el-form-item>
                    <el-form-item label="地图级别：" prop="mapLevel" v-if="rowForm.coordinate > 0" style="display: none;">
                        <el-input v-model="rowForm.mapLevel" type="number" min="1" max="30"/>
                    </el-form-item>
                </div>
	        </el-form>
    	</div>
    </div>
</template>

/* JS */
<script>
    import ApiOam from '@/request/api-oam'
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2022/1/20
         */
        name: 'ProjectDetail',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2022/1/20
         */
        props: {
            // 节点信息
            nodeData: Object,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2022/1/20
         */
        data() {
            return{
                editFlag: false,
                addAreaFlag: false,
                operationLock: false,
                rowForm: {
                    name: '',
                    hasArea: 0,
                    website: '',
                    areaName: '',
                    mapIds: [],
                    coordinate: 0,
                    centerLng: '',
                    centerLat: '',
                    mapLevel: 1,
                },
                row: {},
                maps: [],
                projectWebsite: '',
                hasAreas: {
                    0: '否',
                    1: '是'
                },
                coordinates: {
                    0: '直角坐标系',
                    1: 'GPS坐标系',
                    2: '高德地图坐标系',
                    3: '百度地图坐标系',
                },
                rules:{
                    name: [
                        { required: true, message: '名称不能为空', trigger: 'blur' }
                    ],
                    hasArea: [
                        { required: true, message: '请选择是否分区域', trigger: 'blur' }
                    ],
                    coordinate: [
                        { required: true, message: '请选择使用坐标系', trigger: 'blur' },
                    ],
                    centerLng: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.rowForm.coordinate > 0 && value == '') {
                                    new callback(new Error("经度不能为空"));
                                }else if(parseFloat(value) > 180 || parseFloat(value) < -180 ){
                                    new callback(new Error("纬度范围-180~180"));
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    centerLat: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.rowForm.coordinate > 0 && value == '') {
                                    new callback(new Error("纬度不能为空"));
                                }else if(parseFloat(value) > 90 || parseFloat(value) < -90 ){
                                    new callback(new Error("纬度范围-90~90"));
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    mapLevel: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.rowForm.coordinate > 0 && value == '') {
                                    new callback(new Error("地图级别不能为空"));
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                }
            }
        },
        created(){
        },
        mounted(){
            this.$nextTick(()=>{
            })
        },
        watch: {
            addAreaFlag: {
                handler(newVal, oldVal){
                    // console.log(newVal, oldVal)
                    // this.searchBs();
                    if(newVal){
                        this.searchMap();
                    }
                },
                immediate: true,
                deep:true,
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2022/1/20
         */
        methods:{
            /**
             * 单选按钮发生变化
             * */
            changeAreaHandler(value){
                this.rowForm.hasArea = value;
                if(this.rowForm.hasArea == 0){
                    this.rowForm.areaName = '';
                    this.addAreaFlag = false;
                }else{
                    if(this.nodeData.node.hasArea == 0){
                        this.addAreaFlag = true;
                    }
                }
            },
            /**
             * 单选按钮发生变化
             * */
            changeCoordHandler(value){
                this.rowForm.coordinate = value;
            },
            /**
             * 编辑
             */
            edit(){
                this.rowForm.id = this.nodeData;
                this.rowForm.name = this.nodeData.name;
                this.rowForm.hasArea = this.nodeData.node.hasArea;
                this.rowForm.website = this.nodeData.node.website;
                this.rowForm.coordinate = this.nodeData.node.coordinate;
                this.rowForm.centerLat = this.nodeData.node.centerLat;
                this.rowForm.centerLng = this.nodeData.node.centerLng;
                this.rowForm.mapLevel = this.nodeData.node.mapLevel;
                this.editFlag = true;
            },
            /**
             * 取消
             */
            cancel(){
                this.editFlag = false;
                this.addAreaFlag = false;
            },
            /**
             * 保存
             */
            save(){
                this.$refs.rowForm.validate(valid => {
                    if (!valid) return false;
                    this.operationLock = true;
                    this.$request.postJsonRequest(ApiOam.Update_Project_Uri, {
                        projectId: this.nodeData.id,
                        projectName: this.rowForm.name,
                        website: this.rowForm.website,
                        hasArea: this.rowForm.hasArea,
                        areaName: this.rowForm.areaName,
                        mapIds: this.rowForm.mapIds,
                        coordinate: this.rowForm.coordinate,
                        centerLat: this.rowForm.centerLat,
                        centerLng: this.rowForm.centerLng,
                        mapLevel: this.rowForm.mapLevel
                    }).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: '保存成功！',
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            this.nodeData.name = this.rowForm.name;
                            this.nodeData.node.hasArea = this.rowForm.hasArea;
                            this.nodeData.node.website = this.rowForm.website;
                            this.nodeData.node.coordinate = this.rowForm.coordinate;
                            this.nodeData.node.centerLat = this.rowForm.centerLat;
                            this.nodeData.node.centerLng = this.rowForm.centerLng;
                            this.nodeData.node.mapLevel = this.rowForm.mapLevel;
                            this.$emit('setSelectVal', this.nodeData, true);
                            this.$store.state.currentProjectName = this.rowForm.name;
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        this.cancel();
                        this.operationLock = false;
                    }).catch(error => {
                    	this.operationLock = false;
                    	console.error('修改项目异常', ApiOam.Update_Project_Uri, error);
                    })
                });
            },
            /**
             * 添加
             */
            add(){
                this.$emit("addNode", true);
            },
            /**
             * 查询地图信息
             */
            searchMap(){
                this.$request.postJsonRequest(ApiOam.Find_Map_By_ProjectId_Uri, {
                    projectId: this.nodeData.project.projectId
                }).then(result => {
                    this.maps = Object.assign([], []);
                    if(result.code == 0){
                        this.maps = result.data;
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(error => {
                    console.error('查询项目地图异常', ApiOam.Find_Map_By_ProjectId_Uri, error);
                })
            },
            clickMap(){
                if(this.rowForm.coordinate == 3){
                    // 弹出百度地图
                }
            }
        }
    }
</script>

/* CSS */
<style lang="scss" scoped >

</style>



// WEBPACK FOOTER //
// src/components_pages/Organization/ProjectDetail.vue